import { useCallback, useRef, useState } from "react";

// Tracks an element's rendered height via ResizeObserver, the height
// counterpart of useElementWidth, with the same callback-ref shape and reasons.
//
// Reads the border box (getBoundingClientRect), not the observer entry's content
// box, so a caller positioning something against the element's outer edge — a
// popover opened over a card — gets its full height, borders included.
export const useElementHeight = <T extends HTMLElement>() => {
  const [height, setHeight] = useState(0);
  const observerRef = useRef<ResizeObserver | null>(null);

  const ref = useCallback((element: T | null) => {
    observerRef.current?.disconnect();
    observerRef.current = null;

    if (!element) return;

    setHeight(element.getBoundingClientRect().height);

    const observer = new ResizeObserver(() =>
      setHeight(element.getBoundingClientRect().height)
    );
    observer.observe(element);
    observerRef.current = observer;
  }, []);

  return { ref, height };
};
